import { StatusBadge } from "@nymbl/nos2-rules";
import type { PersonMetrics } from "@/lib/team/metrics";

const TAG_TONES = { "below-target": "warning", "under-guidance": "neutral" } as const;
const TAG_LABELS = { "below-target": "Below target", "under-guidance": "Under guidance" };

export function PersonTags({ person }: { person: PersonMetrics }) {
  if (!person.belowTarget && !person.underPlanned) return null;
  return (
    <div className="mt-1 flex flex-wrap gap-1">
      {person.belowTarget && (
        <StatusBadge status="below-target" tones={TAG_TONES} labels={TAG_LABELS} />
      )}
      {person.underPlanned && (
        <StatusBadge status="under-guidance" tones={TAG_TONES} labels={TAG_LABELS} />
      )}
    </div>
  );
}
